var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoAprovarOrcamento(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "32px",
    viewBox: "0 0 360 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "buttons/4 tags/1 navigation-filter/small/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.4675298e-13,7.99165249 C1.4675298e-13,3.57798469 3.5840954,0 7.99230925,0 L344.007691,0 C348.421721,0 352,3.5800761 352,7.99165249 L352,16.0083475 C352,20.4220153 348.415905,24 344.007691,24 L7.99230925,24 C3.57827873,24 1.4675298e-13,20.4199239 1.4675298e-13,16.0083475 L1.4675298e-13,7.99165249 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.0%",
    y: "-20.8%",
    width: "104.0%",
    height: "158.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-163.000000, -457.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(156.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buttons/4-tags/1-navigation-filter/small/default",
    transform: "translate(11.000000, 309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background-shadow",
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.4675298e-13,7.99165249 C1.4675298e-13,3.57798469 3.5840954,0 7.99230925,0 L344.007691,0 C348.421721,0 352,3.5800761 352,7.99165249 L352,16.0083475 C352,20.4220153 348.415905,24 344.007691,24 L7.99230925,24 C3.57827873,24 1.4675298e-13,20.4199239 1.4675298e-13,16.0083475 L1.4675298e-13,7.99165249 Z",
    id: "background-color",
    fill: "#00BB5B"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Servi\\xE7os-r\\xE1pidos",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 14,
    fontWeight: "bold",
    "line-spacing": 18,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 116.479,
    y: 17
  }, "Aprovar or\xE7amento"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAprovarOrcamento);
export default __webpack_public_path__ + "static/media/PictoAprovarOrcamento.490c62fa05053072e797db402b304f29.svg";
export { ForwardRef as ReactComponent };